document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  const guidesSection = document.querySelector('.ambassador__guides--wrapper');
  if (!guidesSection) return;

  const title = guidesSection.querySelector('h2');
  const article = guidesSection.querySelector('.s-featured-articles__item');
  const card = guidesSection.querySelector('.c-article-card');
  const tags = card?.querySelectorAll('.c-article-card__tag');
  const cardImage = card?.querySelector('.c-article-card__img');
  const cardTitle = card?.querySelector('.c-article-card__title');
  const cardInfo = card?.querySelector('.c-article-card__info');
  const btnSpan = guidesSection.querySelector('.ambassador__guides_posts--btn span');
  const faqTitle = guidesSection.querySelector('.ambassador__guides_faq h3');
  const faqItems = guidesSection.querySelectorAll('.ambassador__guides_faq--list-item');

  if (title) {
    gsap.fromTo(title,
      { y: -20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.6,
        ease: "power2.out",
        scrollTrigger: {
          trigger: title,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (card) {
    if (tags?.length) {
      tags.forEach(tag => {
        gsap.fromTo(tag,
          { x: -10, scale: 0.95, opacity: 0 },
          {
            x: 0,
            scale: 1,
            opacity: 1,
            duration: 0.4,
            ease: "power2.out",
            scrollTrigger: {
              trigger: tag,
              start: "top 80%",
              toggleActions: "play reverse play reverse"
            }
          }
        );
      });
    }

    if (cardImage) {
      gsap.fromTo(cardImage,
        { scale: 1.05, opacity: 0 },
        {
          scale: 1,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: {
            trigger: cardImage,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (cardTitle) {
      gsap.fromTo(cardTitle,
        { y: -20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: cardTitle,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }

    if (cardInfo) {
      gsap.fromTo(cardInfo,
        { y: 20, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          delay: 0.1,
          duration: 0.5,
          ease: "power2.out",
          scrollTrigger: {
            trigger: cardInfo,
            start: "top 80%",
            toggleActions: "play reverse play reverse"
          }
        }
      );
    }
  }

  if (btnSpan) {
    gsap.fromTo(btnSpan,
      { scale: 0.95, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 0.4,
        ease: "power2.out",
        scrollTrigger: {
          trigger: btnSpan,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (faqTitle) {
    gsap.fromTo(faqTitle,
      { y: -20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: faqTitle,
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  if (faqItems.length) {
    gsap.fromTo(faqItems,
      { y: 20, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.5,
        stagger: 0.1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: faqItems[0],
          start: "top 80%",
          toggleActions: "play reverse play reverse"
        }
      }
    );
  }

  ScrollTrigger.refresh();
});
